/**
 * Forgot-password feature strings.
 *
 * Namespace: forgotPassword
 */
export const forgotPassword = {
  // Page
  page: {
    title: "Elfelejtett jelszó",
    subtitle: "Adja meg az email címét a jelszó visszaállításához",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Form fields
  form: {
    emailLabel: "Email cím",
    emailPlaceholder: "pelda@example.com",
    submitButton: "Küldés",
    loadingButton: "Küldés...",
  },

  // Errors
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
  },

  // Success
  success: {
    title: "E-mail elküldve!",
    message:
      "Ha az email cím szerepel a rendszerünkben, hamarosan kap egy levelet a jelszó visszaállításához.",
    backToLogin: "Vissza a bejelentkezéshez",
  },
} as const;
